module.exports = __webpack_public_path__ + "static/lamane-1-83738b9b125ee3dc293b8b4fadefdacb.jpg";